import * as React from 'react'
import { CommonSeriesSettings, Legend, Series, Tooltip } from 'devextreme-react/chart'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'
import { PlatformContext } from '../../../../components/context/platform'

export const RemixerChart: React.FunctionComponent = ({ }) => {
    const platform = React.useContext(PlatformContext)

    if (platform !== 'supreme') {
        return null
    }

    return (
        <BPMChart title={"Remixer"} type='stackedbar'
            onRequestLoad={(options, signal) => {
                return BPMAnalyticsAPI.get<any>('downloads/remixer', options, signal)
            }} visualRangeEnd={100}>

            <CommonSeriesSettings
                argumentField="remixer"
                hoverMode="allArgumentPoints"
            />

            <Series
                type="stackedbar"
                name="New in period"
                valueField="downloads_new_in_period"
                axis="downloads"
            />
            <Series
                type="stackedbar"
                name="Existing catalog"
                valueField="downloads_existing"
                axis="downloads"
            />
            <Tooltip
                enabled={true}
                customizeTooltip={(info: any) => {
                    console.log(info)
                    const d = info.point.data;
                    const total = d.downloads_total ?? 0;
                    const nu = d.downloads_new_in_period ?? 0;
                    const ex = d.downloads_existing
                    const pctNew = d.pct_new
                    return {
                        html: `
                <div style="min-width:220px">
                  <div><b>${d.remixer}</b></div>
                  <div>Total: ${total.toLocaleString()}</div>
                  <div>New in period: ${nu.toLocaleString()}</div>
                  <div>Existing: ${ex.toLocaleString()}</div>
                  <div>Percent new: ${pctNew.toLocaleString()}%</div>
                </div>`
                    };
                }}
            />
            <Legend visible />
        </BPMChart >
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Downloads/charts/RemixerChart.tsx